import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
    Box,
    Paper,
    Typography,
    CircularProgress,
} from "@mui/material";
import backgroundImage from '../../../assets/images/Asset-3-100.jpg';

import { PaymentReceipt } from "../components/PaymentReceipt";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import axios from "axios";

export const LayoutResponse = () => {
    const [searchParams] = useSearchParams();
    const ref_payco = searchParams.get('ref_payco');
    const [status, setStatus] = useState("loading");
    const [data, setData] = useState(null);

    const sanitizeRefPayco = (raw) => {
        if (!raw || typeof raw !== "string") return null;
        const s = raw.trim();
        if (!/^[A-Za-z0-9_-]{6,128}$/.test(s)) return null;
        return s;
    };

    const refPayco = sanitizeRefPayco(ref_payco) || null;

    useEffect(() => {
        console.log("refPayco -> ", refPayco);
        console.log("ref_payco -> ", ref_payco);
        if (!refPayco) {
            if (ref_payco) {
                setStatus("invalid-ref");
            } else {
                setStatus("no-ref");
            }
            return;
        }

        const encodedRef = encodeURIComponent(refPayco);
        const url = `https://secure.epayco.co/validation/v1/reference/${encodedRef}`;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000);



        axios
            .get(url, {
                headers: {
                    "Content-Type": "application/json",
                },
                signal: controller.signal,
            })
            .then((res) => {
                clearTimeout(timeout);

                const json = res.data;
                if (!json || !json.success) {
                    setStatus("error");
                    return;
                }

                const info = json.data || null;
                setData(info);

                switch (info?.x_cod_response) {
                    case 1:
                        setStatus("ok");
                        break;
                    case 2:
                        setStatus("error");
                        break;
                    case 3:
                        setStatus("pending");
                        break;
                    case 4:
                        setStatus("error");
                        break;
                    default:
                        setStatus("unknown");
                }
            })
            .catch((err) => {
                clearTimeout(timeout);
                console.error("Validation request failed:", err);
                if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
                    setStatus("error");
                } else {
                    setStatus("error");
                }
            });

        return () => {
            controller.abort();
            clearTimeout(timeout);
        };

    }, [refPayco]);

    // -------------------------------
    // Render status icon and message
    // -------------------------------
    const renderStatusBlock = () => {
        switch (status) {
            case "loading":
                return (
                    <>
                        <Typography variant="h6" textAlign="center">
                            Consultando transacción…
                        </Typography>
                        <Box textAlign="center" mt={2}>
                            <CircularProgress />
                        </Box>
                    </>
                );

            case "no-ref":
                return (
                    <Typography color="error" variant="h6" textAlign="center">
                        No se encontró la referencia del pago.
                    </Typography>
                );

            case "error":
                return (
                    <>
                        <ErrorIcon sx={{ fontSize: 48, color: "error.main", display: "block", margin: "0 auto" }} />
                        <Typography color="error" variant="h6" textAlign="center">
                            Hubo un error validando la transacción.
                        </Typography>
                    </>
                );

            case "pending":
                return (
                    <>
                        <HourglassBottomIcon sx={{ fontSize: 48, color: "orange", display: "block", margin: "0 auto" }} />
                        <Typography sx={{ color: "orange", fontWeight: 600 }} variant="h6" textAlign="center">
                            Pago pendiente de aprobación
                        </Typography>
                    </>
                );

            case "ok":
                return (
                    <>
                        <CheckCircleIcon sx={{ fontSize: 48, color: "green", display: "block", margin: "0 auto" }} />
                        <Typography sx={{ color: "green", fontWeight: 600 }} variant="h6" textAlign="center">
                            ¡Pago aprobado!
                        </Typography>
                    </>
                );

            default:
                return (
                    <Typography variant="h6" textAlign="center">
                        Estado desconocido.
                    </Typography>
                );
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "flex-end" },
                alignItems: "center",
                background: `url('${backgroundImage}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: '100vh',
                width: '100vw',
                p: { xs: 2, md: 3 },
                pr: { md: 12 },
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    maxWidth: 600,
                    width: "100%",
                    maxHeight: "calc(100vh - 40px)",
                    overflowY: "auto",
                    p: 3,
                    bgcolor: "rgba(255,255,255,0.9)",
                    backdropFilter: "blur(5px)",
                    borderRadius: 3,
                }}
            >
                {renderStatusBlock()}
                {data && <PaymentReceipt info={data} />}
            </Paper>
        </Box>
    );
}
